var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9688 3.90625C17.9688 3.47478 17.619 3.125 17.1875 3.125L7.8125 3.125C7.38103 3.125 7.03125 3.47478 7.03125 3.90625L7.03125 21.0938C7.03125 21.5252 7.38103 21.875 7.8125 21.875H17.1875C17.619 21.875 17.9688 21.5252 17.9688 21.0938V3.90625ZM17.1875 1.5625C18.4819 1.5625 19.5312 2.61183 19.5312 3.90625V21.0938C19.5312 22.3882 18.4819 23.4375 17.1875 23.4375H7.8125C6.51808 23.4375 5.46875 22.3882 5.46875 21.0938L5.46875 3.90625C5.46875 2.61183 6.51808 1.5625 7.8125 1.5625L17.1875 1.5625Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59375 5.46875C8.59375 5.03728 8.94353 4.6875 9.375 4.6875H15.625C16.0565 4.6875 16.4062 5.03728 16.4062 5.46875C16.4062 5.90022 16.0565 6.25 15.625 6.25H9.375C8.94353 6.25 8.59375 5.90022 8.59375 5.46875Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.25285665da7741fdfdcc9844f62bde8b.svg";
export { ForwardRef as ReactComponent };